import { render, staticRenderFns } from "./ChoosePortalRole.vue?vue&type=template&id=d5eb63c6&scoped=true&"
import script from "./ChoosePortalRole.vue?vue&type=script&lang=js&"
export * from "./ChoosePortalRole.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePortalRole.vue?vue&type=style&index=0&id=d5eb63c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5eb63c6",
  null
  
)

export default component.exports